import DetailsFooter from '../components/AppCenter/components/DetailsFooter';
import DetailsFees from '../components/AppCenter/components/DetailsFees';
import DetailsHeader from '../components/AppCenter/components/DetailsHeader';
import DetailsPhotoSections from '../components/AppCenter/components/DetailsPhotoSection';
import DetailsSetup from '../components/AppCenter/components/DetailsSetup';
import DetailsCTASection from '../components/AppCenter/components/DetailsCTASection';
import DetailsFeatures from '../components/AppCenter/components/DetailsFeatures';
import DetailsSectionHeader from '../components/AppCenter/components/DetailsSectionHeader';
import DetailsTermsConditions from '../components/AppCenter/components/DetailsTermsConditions';
import DetailsCrossSell from '../components/AppCenter/components/DetailsCrossSell';
import DetailsTestimonials from '../components/AppCenter/components/DetailsTestimonials';
import {
  DETAILS_HEADER,
  DETAILS_FEATURES,
  DETAILS_PHOTO_ROW,
  DETAILS_FEES,
  DETAILS_FOOTER,
  DETAILS_TERMS_AND_CONDITIONS,
  DETAILS_SECTION_HEADER,
  DETAILS_SETUP,
  DETAILS_CTA_SECTION,
  DETAILS_TESTIMONIALS,
  DETAILS_CROSS_SELL
} from '../../server/lib/Constants';

export default {
  [DETAILS_HEADER]: DetailsHeader,
  [DETAILS_FEATURES]: DetailsFeatures,
  [DETAILS_PHOTO_ROW]: DetailsPhotoSections,
  [DETAILS_FEES]: DetailsFees,
  [DETAILS_FOOTER]: DetailsFooter,
  [DETAILS_TERMS_AND_CONDITIONS]: DetailsTermsConditions,
  [DETAILS_SECTION_HEADER]: DetailsSectionHeader,
  [DETAILS_SETUP]: DetailsSetup,
  [DETAILS_CTA_SECTION]: DetailsCTASection,
  [DETAILS_TESTIMONIALS]: DetailsTestimonials,
  [DETAILS_CROSS_SELL]: DetailsCrossSell
};
